import React, { ComponentClass, ReactElement } from 'react';

import { SingleSourceOfTruth } from '@philips-emr/tws-core';
import { LocaleService } from '@philips-emr/tws-core/lib/services';
import { getBreakpoint } from '@philips-emr/tws-utils';

import ReactEngineBridge from '../bridge/react-engine-bridge';
import { Node, NodeProps } from '../metadata';
import { resolveProps, shouldRenderElement } from '../util';

import Renderer from './renderer';

export interface EngineProps {
  onMount: Function;
  onUnmount: Function;
  ssot: SingleSourceOfTruth;
  uuid: string;
  identifier?: string;
  [k: string]: unknown;
}

class ReactRenderer extends Renderer<ComponentClass<unknown>, ReactElement> {

  private cache = new Map<string, ComponentClass<unknown>>();

  createElement(component: ComponentClass, props: NodeProps, children: Node[]): ReactElement | null {
    const breakpoint = this.getBreakpoint();
    const locale = LocaleService.getCurrentLocale();

    if (!shouldRenderElement(props, { breakpoint, locale })) {
      return null;
    }

    const _children = children ? children.map(this.transverseMetadata) : null;

    const resolvedProps = resolveProps(props, breakpoint, locale);
    return React.createElement(component, resolvedProps, _children);
  }

  getBreakpoint(): string {
    return getBreakpoint();
  }

  getComponentByType(node: Node): ComponentClass<unknown> {
    const { type } = node;

    if (!this.cache.has(type)) {
      const component = super.getComponentByType(node);
      const decoratedComponent = ReactEngineBridge(component);
      this.cache.set(type, decoratedComponent as ComponentClass<unknown>);
    }

    const component = this.cache.get(type);

    if (!component){
      throw new Error(`[ReactRenderer]: component not found: '${type}'`);
    }

    return component;
  }
}

export default ReactRenderer;
